import {
  alfaSettingsGeneral,
  alfaSettingsInitialValues,
  zAlfaSettings,
} from '@/general/src/insuranceProvider/alfa/shared.js'
import {
  ingosSettingsGeneral,
  ingosSettingsInitialValues,
  zIngosSettings,
} from '@/general/src/insuranceProvider/ingos/shared.js'
import { getConstKeys } from '@/general/src/other/getConstKeys.js'
import { z } from 'zod'
import type { InsuranceProvider as InsuranceProviderPrisma } from '@/backend/src/services/other/prisma.js'
import { checkEnumEq } from '@/general/src/other/checkEnumEq.js'

export const insuranceProvidersMap = {
  alfa: 'Альфастрахование',
  ingos: 'Ингосстрах',
} as const
export const insuranceProviders = getConstKeys(insuranceProvidersMap)
export type InsuranceProvider = keyof typeof insuranceProvidersMap
checkEnumEq<InsuranceProvider, InsuranceProviderPrisma, true>()
export const zInsuranceProvider = z.enum(insuranceProviders)
export const insuranceProvidersOptions = insuranceProviders.map((key) => ({
  value: key,
  label: insuranceProvidersMap[key],
}))
export const getInsuranceProvidersOptions = ({ insuranceProviders }: { insuranceProviders: InsuranceProvider[] }) =>
  insuranceProvidersOptions.filter((option) => insuranceProviders.includes(option.value))

export const getInsuranceProviderTitle = (provider: keyof typeof insuranceProvidersMap) => {
  return insuranceProvidersMap[provider]
}

export type InsuranceProviderSettingsGeneral = {
  insuranceProvider: InsuranceProvider
  zSchema: z.ZodSchema
  initialValues: Record<string, any>
  keysMap: Record<string, string>
  keys: string[]
}
export const insuranceProvidersSettingsGenerals = [alfaSettingsGeneral, ingosSettingsGeneral]

export const insuranceProvidersSettingsInitialValues = {
  alfa: alfaSettingsInitialValues,
  ingos: ingosSettingsInitialValues,
} satisfies Record<InsuranceProvider, any>
export type InsuranceProvidersSettings = typeof insuranceProvidersSettingsInitialValues
export const zInsuranceProvidersSettings = z.object({
  alfa: zAlfaSettings,
  ingos: zIngosSettings,
})
